import { render } from "./ContentTab.vue?vue&type=template&id=112dd2fd"
import script from "./ContentTab.vue?vue&type=script&lang=js"
export * from "./ContentTab.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src173764375/src/givergy_presenter_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__